import Vue from 'vue'
import Router from 'vue-router'

import Home from "@/view/webapp/Home"
import NewPageAll from "@/view/webapp/NewPageAll"
import NewPageList from "@/view/webapp/NewPageList"
import NewDetail from "@/view/webapp/NewDetail"
import ProductCategoryAll from "@/view/webapp/ProductCategoryAll"
import ProductList from "@/view/webapp/ProductList"
import ProductCategoryDetail from "@/view/webapp/ProductCategoryDetail"
import Case from "@/view/webapp/Case"
import ServicePage from "@/view/webapp/ServicePage"
import AboutUsPage from "@/view/webapp/AboutUsPage"

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: '/Home'
    },
    {
      path: "/Home",//首页
      name: "Home",
      component: Home
    },
    {
      path: "/NewPageAll",//新闻资讯
      name: "NewPageAll",
      component: NewPageAll
    },
    {
      path: "/NewPageList/:model",//新闻列表
      name: "NewPageList",
      component: NewPageList
    },
    {
      path: "/NewDetail/:id",//新闻 案例详情
      name: "NewDetail",
      component: NewDetail
    },
    {
      path: "/ProductCategoryAll",//产品中心
      name: "ProductCategoryAll",
      component: ProductCategoryAll
    },
    {
      path: "/ProductList/:model",//产品二级列表
      name: "ProductList",
      component: ProductList,
    },
    {
      path: "/ProductCategoryDetail/:id",//产品详情
      name: "ProductCategoryDetail",
      component: ProductCategoryDetail
      // () => import("@/view/webapp/ProductCategoryDetail")
    },
    {
      path: "/Case",//典型案例/科技项目 案例展示
      name: "Case",
      component: Case
    },
    {
      path: "/ServicePage",//服务支持
      name: "ServicePage",
      component: ServicePage
    },
    {
      path: "/AboutUsPage",//关于我们
      name: "AboutUsPage",
      component: AboutUsPage
    },
  ]
})
router.afterEach(() => {
  document.getElementById("app").scrollIntoView();
});
export default router

// 解决重复点击同一路由报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


// WEBPACK FOOTER //
// ./src/router/index.js